module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-flat-screen3-2934a1d97db0ae888ef89d6828839ba1.png";